import Icon from "@ui-kit/icons/Icon.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { useTranslation } from "@shared/utils/internationalization";
import { CheckoutLabelProps } from "./CheckoutLabel.props";

const CheckoutLabel = ({
  totalItemQuantity,
  isWaitlist,
}: CheckoutLabelProps) => {
  const { t } = useTranslation("purchases");

  return (
    <>
      <Flex
        fontWeight="bold"
        lineHeight="1em"
        borderRight={totalItemQuantity > 0 ? "1px solid white" : "none"}
        paddingRight={totalItemQuantity > 0 ? "10px" : "0px"}
      >
        {isWaitlist && totalItemQuantity > 0 ? (
          <span>{t("Join Waitlist").toUpperCase()}</span>
        ) : (
          <span>{t("Checkout").toUpperCase()}</span>
        )}
      </Flex>
      {totalItemQuantity > 0 && (
        <Flex alignItems="center" paddingLeft="xs" fontWeight="bold">
          <Icon.Cart.Outline color="contrast" boxSize="element.md" mr="2xs" />
          <span>{totalItemQuantity}</span>
        </Flex>
      )}
    </>
  );
};

export default CheckoutLabel;
